import 'unfetch/polyfill';
import './request-idle-callback-polyfill';

import MetricalClient from './metricalClient';

export default function createMetricalClient({
    apiKey,
    apiUrl,
    domain,
    debug = false,
}) {
    if (!apiKey) {
        console.error('[metrical-client-script] - missing api key');
    }
    const client = new MetricalClient({ apiKey, apiUrl, domain, debug });
    return {
        track: client.track,
    };
}

window.createMetricalClient = createMetricalClient;
